import { Component, OnInit } from '@angular/core';

import { MENU } from 'src/app/data/menu';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss']
})
export class SideBarComponent implements OnInit {

  public menuData = MENU;

  public isCollapsed = true;

  public firstName: string = 'First Name';

  constructor() { }

  ngOnInit(): void {
  }

}
